export class EquipmentResponse {
  content: EquipmentContent[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: {
    sort: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  size: number;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  totalElements: number;
  totalPages: number;
}

export enum EQUIPMENT_STATUS {
  AVAILABLE = 'AVAILABLE', // device is free, in the office
  ALLOCATED = 'ALLOCATED', // device is allocated to customer's pbx
  ASSIGNED = 'ASSIGNED'   // device is assigned to a user
}

export class EquipmentContent {
  handsets: Handset[];
  blacklisted: boolean;
  blf: boolean;
  id: number;
  last_provisioning_date: any;
  mac_address: string;
  model: string;
  pbx: Pbx;
  status: EQUIPMENT_STATUS;
  user: UserEquipment;
  user_agent: any;
  outbound_did: string;
  fw_update: boolean;
}

export class Handset {
  assigned: boolean;
  id: number;
  ipui: string;
  user: UserEquipment;
  outbound_did: string;
  isLoading?: boolean;
}

export class UserEquipment {
  email: string;
  enabled: boolean;
  extension: {
    id: number;
    number: number;
  }
  first_name: string;
  id: number;
  last_name: string;
}

export class Pbx {
  admin: UserEquipment;
  alphaname: string;
  company_id: number;
  id: number;
  is_enabled: boolean;
  kazoo_id: string;
  kazoo_instance_id: string;
  queue_module: string;
  language: string;
  outbound_did: any
  pivotEnabled: boolean
  realm: string;
}

export interface EquipmentFilters {
  macAddress?: string;
  model?: string;
  alphaname?: string;
  pbxId?: number;
  ipui?: string;
}
